import { IoIosClose } from "react-icons/io";
import { MdDone } from "react-icons/md";
import { Formik, Field, Form, useFormikContext } from "formik";
import css from "./ArchiveModal.module.css";
import { useDispatch } from "react-redux";
import { addItemToArchive } from "../../../redux/archive/operations.js";
import { useEffect, useRef, useState } from "react";
import { showToast } from "../../../utils/showToast.js";

const archiveReasons = [
  {
    id: "2",
    statusClass: css.lightBlue,
    statusText: "СПІВРОБІТНИК",
    background: "var(--status-gradient-archive-light-blue)",
    borderColor: "var(--glow-archive-light-blue)",
  },
  {
    id: "3",
    statusClass: css.lightBlue,
    statusText: "ВИПАДКОВИЙ",
    background: "var(--status-gradient-archive-light-blue)",
    borderColor: "var(--glow-archive-light-blue)",
  },
  {
    id: "1",
    statusClass: css.lightBlue,
    statusText: "ДУБЛЬ",
    background: "var(--status-gradient-archive-light-blue)",
    borderColor: "var(--glow-archive-light-blue)",
  },
  {
    id: "4",
    statusClass: css.violet,
    statusText: "ВІДМОВА",
    background: "var(--status-gradient-archive-violet)",
    borderColor: "var(--glow-archive-violet)",
  },
  // {
  //   id: "5",
  //   statusClass: css.violet,
  //   statusText: "НЕ ПРИЇХАВ",
  //   background: "var(--status-gradient-archive-violet)",
  //   borderColor: "var(--glow-archive-violet)",
  // },
  {
    id: "6",
    statusClass: css.violet,
    statusText: "РЕЙТИНГ",
    background: "var(--status-gradient-archive-violet)",
    borderColor: "var(--glow-archive-violet)",
  },
  {
    id: "7",
    statusClass: css.red,
    statusText: "НЕ ДОПОМОГЛИ",
    background: "var(--status-gradient-view-repair)",
    borderColor: "var(--glow-red)",
  },
];

function ReasonEffect({ archiveReasons, setSelectedReason }) {
  const { values } = useFormikContext();

  useEffect(() => {
    const reason = archiveReasons.find(r => r.id === values.reason_add);
    setSelectedReason(reason);
  }, [values.reason_add, archiveReasons, setSelectedReason]);

  return null;
}

export default function ArchiveModal({
  onClose,
  carId,
  plate,
  location,
  isRecommendation,
  onSuccess,
}) {
  const dispatch = useDispatch();
  const [selectedReason, setSelectedReason] = useState(null);
  const wrapperRef = useRef(null);

  const handleSubmit = async values => {
    if (!carId) {
      console.error("Помилка: у запису відсутній car_id");
      showToast("Помилка: у запису відсутній car_id", "error");
      return;
    }

    const itemData = {
      record_id: carId,
      reason_record: Number(values.reason_add),
      reason_add_name: selectedReason.statusText,
      comment: values.comment || "",
    };

    console.log("Дані для архівації:", itemData);

    try {
      await dispatch(addItemToArchive(itemData))
        .unwrap()
        .then(() => {
          showToast("Автомобіль успішно додано в архів!", "success");
          onSuccess();
          onClose();
        });
    } catch (error) {
      showToast(`Помилка: ${error}`, "error");
    }
  };

  return (
    <div className={css.wrapper} ref={wrapperRef}>
      <button className={css.exitBtn} onClick={onClose}>
        <IoIosClose className={css.icon} />
      </button>

      <Formik
        initialValues={{
          comment: "",
          reason_add: "1",
        }}
        onSubmit={handleSubmit}
      >
        <Form className={css.form}>
          <ReasonEffect
            archiveReasons={archiveReasons}
            setSelectedReason={setSelectedReason}
          />
          <div
            className={css.reasonCommentWrapper}
            data-tour-carslist="step-3.3"
          >
            {!isRecommendation && (
              <Field
                as="select"
                id="reason_add"
                name="reason_add"
                className={`${css.select} ${
                  selectedReason ? selectedReason.statusClass : ""
                }`}
                style={{
                  background: selectedReason
                    ? selectedReason.background
                    : undefined,
                  borderColor: selectedReason
                    ? selectedReason.borderColor
                    : undefined,
                }}
              >
                {archiveReasons.map(reason => (
                  <option key={reason.id} value={reason.id}>
                    {reason.statusText}
                  </option>
                ))}
              </Field>
            )}
            <div className={css.textareaWrapper}>
              <Field
                as="textarea"
                id="comment"
                name="comment"
                placeholder="Коментар..."
                className={css.textarea}
              />
            </div>
          </div>
          <div className={css.btnsGroup}>
            <button type="button" className={css.closeBtn} onClick={onClose}>
              Закрити
            </button>
            <button type="submit" className={css.submitBtn}>
              <MdDone />
              Підтвердити
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}
